import React, { Fragment } from "react";
import { Row, Button } from "reactstrap";
import PublicationShow from "./Show";

const PublicationPreview = ({ toggleTab, handleSubmit, course, companyCentral, isEdit, onContinue }) => {
  return (
    <Fragment>
      <PublicationShow course={course} companyCentral={companyCentral} isPreview={true} />
      <div className="mt-4 text-center d-flex justify-content-center align-items-center">
        <Button
          outline
          color="primary"
          className="mb-5 ms-3"
          onClick={() => toggleTab("publicationForm")}
        >
          <i className="fa fa-arrow-left ms-2"></i>
          Anterior
        </Button>

        <Button
          outline
          color="secondary"
          className="mb-5 ms-2"
          onClick={onContinue}
        >
          Continuar sin publicar
        </Button>

        {isEdit && course.minisitePublication.aasmState.value === "active" ? (
          <Button color="success" className="mb-5 ms-2" href={`/courses/${course.id.value}`}>
            Listo
          </Button>
        ) : (
          <Button color="success" className="mb-5 ms-2" onClick={handleSubmit}>
            Publicar Oferta Laboral
          </Button>
        )}
      </div>
    </Fragment>
  );
};

export default PublicationPreview;
